/**
 * Cart Drawer Custom — Unavela
 * Reservation timer, quick-add, checkout text override.
 */
(function () {
  /* ---- Reservation timer ---- */
  const STORAGE_KEY = "cdc_reservation_end";

  function initTimers() {
    document.querySelectorAll(".cdc-reservation").forEach((bar) => {
      const timerEl = bar.querySelector(".cdc-timer");
      if (!timerEl || bar.dataset.cdcInit) return;
      bar.dataset.cdcInit = "1";

      const minutes = parseInt(bar.dataset.cdcMinutes, 10) || 10;
      let end = parseInt(sessionStorage.getItem(STORAGE_KEY), 10);
      if (!end || end < Date.now()) {
        end = Date.now() + minutes * 60_000;
        sessionStorage.setItem(STORAGE_KEY, String(end));
      }

      const tick = () => {
        const rem = end - Date.now();
        if (rem <= 0) {
          timerEl.textContent = "0:00";
          clearInterval(id);
          return;
        }
        const m = Math.floor(rem / 60_000);
        const s = Math.floor((rem % 60_000) / 1000);
        timerEl.textContent = `${m}:${s < 10 ? "0" : ""}${s}`;
      };
      tick();
      const id = setInterval(tick, 1000);
    });
  }

  /* ---- Quick Add to Cart ---- */
  function getCartSectionIds() {
    const ids = new Set();
    document.querySelectorAll("cart-items-component").forEach((el) => {
      if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
    });
    return Array.from(ids);
  }

  async function handleQuickAdd(e) {
    const btn = e.target.closest(".cdc-add-btn");
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    e.preventDefault();
    btn.disabled = true;
    btn.style.opacity = "0.5";

    const root = window.Shopify?.routes?.root || "/";
    const sectionIds = getCartSectionIds();

    try {
      const fd = new FormData();
      fd.append("id", variantId);
      fd.append("quantity", "1");
      if (sectionIds.length) {
        fd.append("sections", sectionIds.join(","));
        fd.append("sections_url", window.location.pathname);
      }

      const addRes = await fetch(`${root}cart/add.js`, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: fd,
        credentials: "same-origin",
      });
      const addData = await addRes.json();

      if (addData && (addData.status || addData.errors)) {
        console.error("Quick add error:", addData);
        return;
      }

      // Fetch plain cart for item_count / totals
      let cart = null;
      try {
        const cartRes = await fetch(`${root}cart.js`, {
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        });
        cart = await cartRes.json();
      } catch (_) {}

      document.dispatchEvent(
        new CustomEvent("cart:update", {
          bubbles: true,
          detail: {
            resource: cart || addData,
            data: {
              source: "cdc-quick-add",
              itemCount: cart ? cart.item_count : undefined,
              sections: addData.sections,
            },
          },
        }),
      );

      const cartDrawer = document.querySelector("cart-drawer-component");
      if (cartDrawer && typeof cartDrawer.open === "function") {
        cartDrawer.open();
      }
    } catch (err) {
      console.error("Quick add failed:", err);
    } finally {
      btn.disabled = false;
      btn.style.opacity = "1";
    }
  }

  /* ---- Checkout button text override ---- */
  function patchCheckoutText() {
    document
      .querySelectorAll(".cart-drawer__dialog[data-cdc-checkout-text]")
      .forEach((dialog) => {
        const text = dialog.dataset.cdcCheckoutText;
        dialog
          .querySelectorAll(".cart__checkout-button .button-text")
          .forEach((el) => {
            if (el.textContent.trim() !== text) el.textContent = text;
          });
      });
  }

  /* ---- Bootstrap ---- */
  function init() {
    initTimers();
    patchCheckoutText();
  }

  document.addEventListener("click", handleQuickAdd);

  // Run on load + on DOM mutations (drawer open / section re-render)
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  const obs = new MutationObserver(init);
  obs.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["open"],
  });
})();
